<template>
  <v-row class="total-payment-section">
    <div v-if="block === 1">
      <v-overlay>
        <v-progress-circular
          :size="100"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </div>
    <v-col cols="12" lg="8" class="pb-0">
      <v-col cols="12" class="total-payment-label">
        <div class="text-center text-h6 text-lg-h5">Total a Pagar</div>
      </v-col>
      <v-col cols="12" class="text-center total-payment">
        <h1 class="">{{ cartTotal.FTotal }}</h1>
      </v-col>
    </v-col>
    <v-col cols="12" lg="4" align-self="center" class="pr-0 pl-0" v-if="canViewPos">
      <v-btn v-if="itemsList.length > 0"
             @click="startPayment"
             block
             color="secondary"
             class="d-flex d-lg-none">
        PAGAR
      </v-btn>
      <v-btn v-if="itemsList.length > 0"
             @click="startPayment"
             color="secondary"
             x-large
             class="d-none d-lg-flex">
        PAGAR
      </v-btn>
    </v-col>
    <v-dialog v-if="remainingTotal > 0" v-model="dialog" persistent max-width="500">
      <v-card>
        <v-toolbar flat>
          <v-btn icon @click="returnToOrder">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Registrar pago</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-4">
          <div class="d-flex justify-space-between">
            <h2 style="font-weight: 400;">Total a pagar:</h2>
            <h2><b>{{ cartTotal.FTotal }}</b></h2>
          </div>
          <div class="d-flex justify-space-between">
            <h2 style="font-weight: 400;">Total pagado:</h2>
            <h2><b>{{ FTotalOrderPaid }}</b></h2>
          </div>
          <div class="d-flex justify-space-between">
            <h2 style="font-weight: 400;">Total restante:</h2>
            <h2><b>{{ FRemainingTotal }}</b></h2>
          </div>
          <div class="d-flex justify-space-between">
            <h2 style="font-weight: 400;">Cambio del cliente:</h2>
            <h2><b>{{ FChange }}</b></h2>
          </div>
          <br/>
          <div v-if="remainingTotal > 0">
            <h2 class="mt-2 mb-2" v-if="selectedPayment < 1 && !disabledBtn">
              Selecciona un método de pago
            </h2>
            <v-row v-if="selectedPayment < 1 && !disabledBtn">
              <v-col cols="12" sm="6">
                <v-btn @click="selectedPayment = 1"
                       block dark color="lightPrimary">
                  <v-icon class="mr-2">mdi-cash</v-icon>
                  Efectivo
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6">
                <v-btn :disabled="disabledBtn" @click="selectedPayment = 1.5"
                       block dark color="lightPrimary">
                  <v-icon class="mr-2">mdi-credit-card</v-icon>
                  Tarjeta
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6">
                <v-btn :disabled="disabledBtn" @click="selectedPayment = 4"
                       block dark color="lightPrimary">
                  <v-icon class="mr-2">mdi-checkbook</v-icon>
                  Cheque
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6">
                <v-btn :disabled="disabledBtn" @click="selectedPayment = 5"
                       block dark color="lightPrimary">
                  <v-icon class="mr-2">mdi-transfer-right</v-icon>
                  Transferencia
                </v-btn>
              </v-col>
            </v-row>

            <v-row v-if="selectedPayment === 1">
              <v-col cols="12" sm="12">
                <v-currency-field v-model="moneyImport" outlined prepend-icon="mdi-cash"
                                  @keypress.enter="makeTransaction"
                                  @input="getChange" color="secondary" label="Importe efectivo">
                </v-currency-field>
              </v-col>
              <h2>Cambio del cliente: {{ transactionChange }}</h2>
            </v-row>

            <v-row v-if="selectedPayment === 1.5">
              <v-col cols="12" sm="12">
                <div>
                  <v-radio-group
                    v-model="cardBrand"
                    row
                    class="pa-0 ma-0 radio-group-space-around"
                  >
                    <v-radio
                      color="secondary"
                      v-for="(provider, idx) in paymentCardBrands"
                      :key="idx"
                      :value="provider.value"
                    >
                      <template #label>
                        <v-img :src="provider.src" max-width="80"/>
                      </template>
                    </v-radio>
                    <v-radio color="secondary" :value="'other'">
                      <template #label>
                        <span class="mr-2">Otra:</span>
                      </template>
                    </v-radio>
                  </v-radio-group>
                  <v-text-field
                    v-if="cardBrand === 'other'"
                    v-model="customCardBrand"
                    dense
                    hide-details
                    solo
                    maxlength="50"
                    counter="50"
                    placeholder="Especificar"
                    class="mb-4"
                  />
                  <v-radio-group
                    v-model="cardType"
                    row
                    class="pa-0 px-2 ma-0 radio-group-space-between"
                  >
                    <v-radio color="secondary" label="Tarjeta de débito" :value="2" />
                    <v-radio color="secondary" label="Tarjeta de crédito" :value="3" />
                  </v-radio-group>
                </div>
              </v-col>
              <v-col cols="12" sm="12">
                <v-currency-field v-model="moneyImport"
                                  @keypress.enter="makeTransaction"
                                  outlined prepend-icon="mdi-credit-card"
                                  class="pb-4"
                                  color="secondary" label="Importe tarjeta">
                </v-currency-field>
                <v-text-field
                v-model="cardLastNumbers"
                type="text"
                inputmode="numeric"
                maxlength="4"
                counter="4"
                @input="cardLastNumbers = onlyDigits(cardLastNumbers).slice(0, 4)"
                @keypress.enter="makeTransaction"
                outlined
                prepend-icon="mdi-numeric"
                class="pb-4"
                color="secondary"
                label="Últimos 4 dígitos de la tarjeta"
                />
                <v-text-field
                v-model="confirmationNumber"
                type="text"
                inputmode="numeric"
                maxlength="50"
                counter="50"
                @input="confirmationNumber = onlyDigits(confirmationNumber).slice(0, 100)"
                @keypress.enter="makeTransaction"
                outlined
                prepend-icon="mdi-shield-check-outline"
                color="secondary"
                label="Número de confirmación"
                />
              </v-col>
            </v-row>

            <v-row v-if="selectedPayment === 4">
              <v-col cols="12" sm="12">
                <v-currency-field v-model="moneyImport"
                                  @keypress.enter="makeTransaction"
                                  outlined prepend-icon="mdi-checkbook"
                                  class="pb-4"
                                  color="secondary" label="Importe cheque">
                </v-currency-field>
                <v-text-field
                v-model="bankName"
                maxlength="50"
                counter="50"
                @keypress.enter="makeTransaction"
                outlined
                prepend-icon="mdi-bank"
                class="pb-4"
                color="secondary"
                label="Nombre del banco"
                />
                <v-text-field
                v-model="confirmationNumber"
                type="text"
                inputmode="numeric"
                maxlength="50"
                counter="50"
                @input="confirmationNumber = onlyDigits(confirmationNumber).slice(0, 100)"
                @keypress.enter="makeTransaction"
                outlined
                prepend-icon="mdi-shield-check-outline"
                color="secondary"
                label="Número de confirmación"
                />
              </v-col>
            </v-row>

            <v-row v-if="selectedPayment === 5">
              <v-col cols="12" sm="12">
                <v-currency-field v-model="moneyImport"
                                  @keypress.enter="makeTransaction"
                                  class="pb-4"
                                  outlined prepend-icon="mdi-transfer-right"
                                  color="secondary" label="Importe transferencia">
                </v-currency-field>
                <v-text-field
                v-model="confirmationNumber"
                type="text"
                inputmode="numeric"
                maxlength="50"
                counter="50"
                @input="confirmationNumber = onlyDigits(confirmationNumber).slice(0, 100)"
                @keypress.enter="makeTransaction"
                outlined
                prepend-icon="mdi-shield-check-outline"
                color="secondary"
                label="Número de confirmación"
                />
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions v-if="selectedPayment > 0">
          <v-spacer></v-spacer>
          <v-btn @click="clearPayment" color="error">Regresar</v-btn>
          <v-btn color="secondary" @click="makeTransaction">
            Terminar pago
          </v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <!-- <v-btn @click="returnToOrder" color="error">Regresar</v-btn> -->

        </v-card-actions>
      </v-card>
      </v-dialog>
      <v-dialog v-else v-model="dialog" persistent max-width="800">
      <v-card>
        <v-toolbar flat>
          <v-btn icon @click="returnToOrder">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Finalizar Venta</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-4">
          <v-row class="top-section" align="stretch">
            <v-col cols="12" md="5" class="pt-0">
              <div class="text-h6" style="text-align: start;">Resumen</div>
              <div class="d-flex mt-1">
                <h2 style="font-weight: 400;">Total a pagar: </h2>
                <h2><b>{{ cartTotal.FTotal }}</b></h2>
              </div>

              <div class="d-flex">
                <h2 style="font-weight: 400;">Total pagado: </h2>
                <h2><b>{{ FTotalOrderPaid }}</b></h2>
              </div>

              <div class="d-flex">
                <h2 style="font-weight: 400;">Total restante: </h2>
                <h2><b>{{ FRemainingTotal }}</b></h2>
              </div>
            </v-col>

            <v-col cols="12" md="7" class="pt-0">
              <div v-if="remainingTotal <= 0 && block === 0" class="d-flex justify-end">
                <div class="d-flex align-start">
                  <v-divider vertical class="v-sep mr-4" />
                  <div style="width: 320px;">
                    <div class="text-h6 mb-2" style="text-align: center;">
                      Facturación
                    </div>
                    <v-radio-group
                      v-model="invoiceRequired"
                      class="mt-1"
                    >
                      <v-radio label="No" value="no" />
                      <v-radio label="Si" value="yes" />
                    </v-radio-group>
                  </div>
                </div>
              </div>
            </v-col>

            <v-divider class="h-sep my-3" />

            <v-col cols="12">
              <v-expand-transition>
                <div v-if="invoiceRequired === 'yes'" class="client-box mt-2">
                  <v-row class="mb-2" aling="center">
                    <v-col cols="12" md="6" v-if="selectedClient && selectedClient.id">
                      <div class="text-subtitle-2 mb-1">
                        Facturar a nombre del cliente
                      </div>
                      <v-radio-group
                      v-model="billToSelectedClient"
                      row
                      class="pa-0 ma-0"
                      >
                        <v-radio color="secondary" label="Sí" value="yes" />
                        <v-radio color="secondary" label="No" value="no" />
                      </v-radio-group>
                    </v-col>
                    <v-col :cols="12" :md="(selectedClient && selectedClient.id) ? 6 : 12">
                      <v-autocomplete
                      v-model="invoiceClientSelected"
                      :items="invoiceClientOptions"
                      :search-input.sync="invoiceClientSearch"
                      :loading="loadingInvoiceClients"
                      item-text="label"
                      return-object
                      no-filter
                      outlined
                      dense
                      clearable
                      hide-no-data
                      label="Buscar por Razón Social / RFC"
                      @update:search-input="searchInvoiceClient"
                      @change="onInvoiceClientChange"
                      />
                    </v-col>
                  </v-row>

                  <div class="text-subtitle-1 mb-2">
                    Datos del cliente
                  </div>

                  <v-row>
                    <v-col cols="12" md="8">
                      <v-text-field
                        v-model="clientName"
                        outlined
                        dense
                        label="Razón Social"
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="clientRfc"
                        outlined
                        dense
                        label="RFC"
                        maxlength="13"
                        :rules="rfcRules"
                        @input="clientRfc = (clientRfc || '').toUpperCase()"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="clientCp"
                        outlined
                        dense
                        label="CP"
                        maxlength="5"
                        inputmode="numeric"
                        @keypress="onlyNumberKeypress"
                        @paste.prevent="onCpPaste"
                        :rules="cpRules"
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        v-model="clientRegimenId"
                        :items="fiscalRegimens"
                        :loading="loadingFiscalRegimens"
                        :disabled="!isValidRfc(clientRfc) || lockFiscalRegimen"
                        item-text="label"
                        item-value="value"
                        outlined
                        dense
                        clearable
                        label="Régimen Fiscal"
                        hide-no-data
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        v-model="clientUsoCfdi"
                        :items="usoCfdiItems"
                        :loading="loadingUsoCfdi"
                        item-text="display"
                        return-object
                        outlined
                        dense
                        label="Uso CFDI"
                      />
                    </v-col>
                  </v-row>
                  <div class="text-subtitle-1 mb-2">
                    Condiciones de pago
                  </div>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                      v-model="clientPaymentType"
                      :items="metodoPagos"
                      item-text="display"
                      return-object
                      outlined
                      dense
                      label="Forma de pago"
                      :disabled="lockSatPaymentFields"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                      v-model="clientPaymentMethod"
                      :items="formaPagos"
                      item-text="display"
                      return-object
                      outlined
                      dense
                      label="Metodo de pago"
                      :disabled="lockSatPaymentFields"
                      />
                    </v-col>
                  </v-row>
                  <v-alert
                  v-if="lockSatPaymentFields"
                    type="info"
                    dense
                    outlined
                  >
                    Por corte de fin de mes en sábado con pago en tarjeta, se asigna
                    automáticamente:
                    Forma de pago 99 (Por definir) y Método de pago PPD.
                  </v-alert>

                </div>
              </v-expand-transition>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="finish-actions">
          <div class="d-flex">
            <h2 style="font-weight: 400;">Cambio del cliente: </h2>
            <h2><b class="ml-2">{{ FChange }}</b></h2>
          </div>

          <v-spacer></v-spacer>

          <v-btn
            v-if="(block === 0 && payments.length > 0) || realPaidCash"
            color="error"
            @click="clearPayments"
          >
            Eliminar pagos
          </v-btn>
          <v-btn
            v-if="remainingTotal <= 0 && block === 0"
            @click="finishOrder"
            color="secondary"
            class="ml-2"
          >
            Terminar orden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// TODO: OBTENER ALGUNA ORDEN QUE NO SE HAYA CERRADO
// (POR QUE SE CERRO LA PAGINA, SE APAGO LA PC ETC) Y MOSTRAR EL MODAL DE PAGO PARA TERMINAR EL PAGO
// import Quotation from '@/components/POS/Quotation.vue';
import Swal from 'sweetalert2';
import { purchaseOrderToTicketData } from '@/serializers/PurchaseOrder.serializer';
import { mapGetters } from 'vuex';
import { FPUtils } from '@/utils/FloatingPointUtils';
import { PurchaseOrderProduct } from '@/models/PurchaseOrder/PurchaseOrderProduct';
import visa from '@/assets/images/icons/payments/img/visa-light.png';
import americanEx from '@/assets/images/icons/payments/img/american-express.png';
import masterCard from '@/assets/images/icons/payments/img/mastercard.png';
import PurchaseOrderService from '../../services/PurchaseOrderService';
import ProductService from '../../services/ProductService';
import CurrencyFormatter from '../../models/CurrencyFormatter';
import InvoicesService from '../../services/InvoicesService';
import ClientService from '../../services/ClientService';
import SatService from '../../services/SatService';

/* eslint-disable no-console */

export default {
  name: 'payment',
  computed: {
    ...mapGetters({
      cartTotal: 'cartTotal',
      authUserData: 'authUserData',
      ticketStruct: 'ticketData',
      itemsList: 'itemsList',
      selectedClient: 'selectedClient',
      totalOrderPaid: 'totalOrderPaid',
      FTotalOrderPaid: 'FTotalOrderPaid',
      stompClient: 'stompClient',
      frontItemsList: 'frontItemsList',
      savedQuotationPurchaseOrderId: 'savedQuotationPurchaseOrderId',
      canViewPos: 'canViewPos',
    }),
    remainingTotal() {
      const orderTotal = FPUtils.round2dec(Number(this.cartTotal.total || 0));
      const paidTotal = FPUtils.round2dec(Number(this.totalOrderPaid || 0));
      return FPUtils.round2dec(orderTotal - paidTotal);
    },
    FRemainingTotal() {
      if (this.remainingTotal > 0) {
        return CurrencyFormatter.format(this.remainingTotal);
      }
      return CurrencyFormatter.format(0);
    },
    cashChange() {
      const remaining = FPUtils.round2dec(this.remainingTotal);
      if (remaining >= 0) return 0;
      return FPUtils.round2dec(Math.abs(remaining));
    },
    FChange() {
      return CurrencyFormatter.format(this.cashChange);
    },
    disabledBtn() {
      return !(this.remainingTotal > 0);
    },
    lockSatPaymentFields() {
      return this.isSatCutoffCase();
    },
  },
  data: () => ({
    invoiceRequired: 'no',
    showNominativeModal: false,
    clientName: '',
    clientRfc: '',
    clientCp: '',
    clientRegimen: null,
    clientUsoCfdi: null,
    clientPaymentMethod: null,
    clientPaymentType: null,
    clientRegimenId: null,
    fiscalRegimens: [],
    fiscalRegimenSearch: '',
    loadingFiscalRegimens: false,
    lockFiscalRegimen: false,
    usoCfdiItems: [],
    loadingUsoCfdi: false,
    invoiceClients: [],
    invoiceClientOptions: [],
    invoiceClientSearch: '',
    cfdis: [],
    formaPagos: [],
    metodoPagos: [],
    loadingFiscal: false,
    billToSelectedClient: 'no',
    invoiceClientSelected: null,
    loadingInvoiceClients: false,
    dialog: false,
    transactionChange: 0,
    moneyImport: null,
    swalText: '¿Desea cerrar la orden y proceder al pago?',
    selectedPayment: 0,
    rfcRules: [
      (v) => !v || v.length >= 12 || 'RFC mínimo 12 caracteres',
      (v) => !v || v.length <= 13 || 'RFC máximo 13 caracteres',
      (v) => !v || /^[A-Z0-9]+$/.test(v) || 'RFC solo letras y números',
    ],
    cpRules: [
      (v) => !v || /^\d{5}$/.test(v) || 'CP debe tener 5 dígitos',
    ],
    paymentCardBrands: [
      {
        src: visa,
        value: 'visa',
      },
      {
        src: masterCard,
        value: 'mastercard',
      },
      {
        src: americanEx,
        value: 'american-express',
      },
    ],
    cardType: 0,
    cardBrand: null,
    customCardBrand: '',
    cardLastNumbers: null,
    confirmationNumber: null,
    bankName: null,
    payments: [],
    change: 0,
    realPaidCash: 0,
    block: 0,
  }),
  methods: {
    toSafeNumber(value) {
      const n = Number(value);
      return Number.isFinite(n) ? FPUtils.round2dec(n) : 0;
    },
    onlyDigits(value) {
      return String(value || '').replace(/\D/g, '');
    },
    trimMax(value, max = 100) {
      return String(value || '').trim().slice(0, max);
    },
    validateAmount(rawAmount, maxLen = 100) {
      const raw = String(rawAmount ?? '').trim();
      if (!raw) return 'Ingresa un importe';
      if (raw.length > maxLen) return `El importe no puede exceder ${maxLen} caracteres`;
      const amount = this.toSafeNumber(rawAmount);
      if (amount <= 0) return 'El importe debe ser mayor a 0';
      return true;
    },
    validateCurrentPaymentInput(paymentMethod, amount) {
      const amountValidation = this.validateAmount(amount);
      if (amountValidation !== true) return amountValidation;
      if (paymentMethod !== 1 && amount > this.toSafeNumber(this.remainingTotal)) {
        return 'El importe no puede ser mayor al total restante en métodos distintos a efectivo';
      }
      if (paymentMethod === 2 || paymentMethod === 3) {
        const cardLastDigits = this.onlyDigits(this.cardLastNumbers);
        if (cardLastDigits.length !== 4) return 'Los últimos 4 dígitos de la tarjeta son obligatorios';
        const conf = this.onlyDigits(this.confirmationNumber);
        if (conf.length < 1 || conf.length > 100) return 'Número de confirmación inválido';
        if (!this.cardBrand) return 'Selecciona una marca de tarjeta';
        if (this.cardBrand === 'other' && !this.trimMax(this.customCardBrand, 100)) {
          return 'Especifica la marca de la tarjeta';
        }
      }
      if (paymentMethod === 4) {
        if (!this.trimMax(this.bankName, 100)) return 'Nombre del banco requerido';
        const conf = this.onlyDigits(this.confirmationNumber);
        if (conf.length < 1 || conf.length > 100) return 'Número de confirmación inválido';
      }
      if (paymentMethod === 5) {
        const conf = this.onlyDigits(this.confirmationNumber);
        if (conf.length < 1 || conf.length > 100) return 'Número de confirmación inválido';
      }
      return true;
    },
    buildPaymentsPayload() {
      const payload = this.payments.map((p) => ({
        totalImport: this.toSafeNumber(p.totalImport),
        paymentMethod: Number(p.paymentMethod),
        confirmationNumber: this.trimMax(p.confirmationNumber, 100) || null,
        cardLastDigits: this.onlyDigits(p.cardLastDigits).slice(0, 4) || null,
        cardBrand: this.trimMax(p.cardBrand, 100) || null,
        bankName: this.trimMax(p.bankName, 100) || null,
        change: this.toSafeNumber(p.change),
      })).filter((p) => p.totalImport > 0 && [1, 2, 3, 4, 5, 6].includes(p.paymentMethod));
      const cashAmount = this.toSafeNumber(this.realPaidCash);
      const hasCash = payload.some((x) => x.paymentMethod === 1);
      if (cashAmount > 0 && !hasCash) {
        payload.push({
          totalImport: cashAmount,
          paymentMethod: 1,
          confirmationNumber: null,
          cardLastDigits: null,
          cardBrand: null,
          bankName: null,
          change: this.toSafeNumber(this.cashChange),
        });
      }
      return payload;
    },
    getNetPaidAmount(paymentsPayload) {
      return FPUtils.round2dec(
        paymentsPayload.reduce((acc, p) => {
          if (p.paymentMethod === 1) return acc + (p.totalImport - this.toSafeNumber(p.change));
          return acc + p.totalImport;
        }, 0),
      );
    },
    resetPaymentState() {
      this.payments = [];
      this.realPaidCash = 0;
      this.$store.dispatch('clearTotalOrderPaid');
      this.dialog = false;
      this.clearPayment();
      this.resetInvoiceState();
    },
    satFormaPagoCodeFromPayments() {
      const totalsByMethod = {};
      this.payments.forEach((p) => {
        const pm = p.paymentMethod;
        const amt = Number(p.totalImport || 0);
        totalsByMethod[pm] = (totalsByMethod[pm] || 0) + amt;
      });
      if (this.realPaidCash && this.realPaidCash > 0) {
        totalsByMethod[1] = (totalsByMethod[1] || 0) + Number(this.realPaidCash);
      }
      const entries = Object.entries(totalsByMethod);
      if (entries.length === 0) return null;
      entries.sort((a, b) => Number(b[1]) - Number(a[1]));
      const pm = Number(entries[0][0]);
      if (pm === 1) return '01';
      if (pm === 4) return '02';
      if (pm === 5) return '03';
      if (pm === 2) return '28';
      if (pm === 3) return '04';
      return null;
    },
    satMetodoPagoCode() {
      return 'PUE';
    },
    async startPayment() {
      const productosSinStock = this.itemsList
        .filter((item) => item.storeInventory === 0)
        .reduce((unique, item) => {
          if (!unique.some((prod) => prod.id === item.id)) {
            unique.push(item);
          }
          return unique;
        }, []);

      if (productosSinStock.length > 0) {
        const nombresProductos = productosSinStock
          .map((item) => `• ${item.name} (Modelo: ${item.model})`)
          .join('<br>');

        Swal.fire({
          title: 'No se puede procesar el pago',
          html: `Los siguientes productos <strong>no tienen inventario</strong>:<br><br>${nombresProductos}`,
          icon: 'error',
          confirmButtonText: 'Entendido',
        });
        return;
      }

      // Si todo está bien, abrir el diálogo de pago
      this.$store.dispatch('clearTotalOrderPaid');
      this.clearPayment();
      this.payments = [];
      this.realPaidCash = 0;
      this.moneyImport = null;
      this.dialog = true;
      try {
        await Promise.all([
          this.preloadInvoiceMisc(),
          this.preloadInvoiceClients(),
          this.loadFiscalRegimens(),
        ]);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    },
    async makeTransaction() {
      let paymentMethod = 0;
      const amount = this.toSafeNumber(this.moneyImport);
      if (this.selectedPayment === 1) {
        const validation = this.validateCurrentPaymentInput(1, amount);
        if (validation !== true) {
          Swal.fire('Error', validation, 'error');
          return;
        }
        this.realPaidCash = this.toSafeNumber(this.realPaidCash + amount);
        this.$store.dispatch('updateTotalOrderPaid', amount);
        this.clearPayment();
        return;
      }
      if (this.selectedPayment === 1.5) {
        if (!this.cardType || ![2, 3].includes(Number(this.cardType))) {
          Swal.fire('Error', 'Selecciona un tipo de tarjeta antes de continuar', 'error');
          return;
        }
        paymentMethod = Number(this.cardType);
      } else {
        paymentMethod = Number(this.selectedPayment);
      }
      const validation = this.validateCurrentPaymentInput(paymentMethod, amount);
      if (validation !== true) {
        Swal.fire('Error', validation, 'error');
        return;
      }
      this.payments.push({
        totalImport: amount,
        paymentMethod,
        confirmationNumber: this.trimMax(this.confirmationNumber, 100) || null,
        cardLastDigits: this.onlyDigits(this.cardLastNumbers).slice(0, 4) || null,
        cardBrand: this.cardBrand === 'other'
          ? this.trimMax(this.customCardBrand, 100)
          : this.trimMax(this.cardBrand, 100),
        bankName: this.trimMax(this.bankName, 100) || null,
      });
      this.$store.dispatch('updateTotalOrderPaid', amount);
      this.clearPayment();
    },
    validateInvoiceForm() {
      if (this.invoiceRequired !== 'yes') return true;
      const rfc = String(this.clientRfc || '').trim().toUpperCase();
      const cp = String(this.clientCp || '').trim();
      if (!this.clientName?.trim()) return 'Razón social requerida';
      if (!(rfc.length === 12 || rfc.length === 13)) return 'RFC inválido (12 o 13)';
      if (!/^\d{5}$/.test(cp)) return 'CP inválido (5 dígitos)';
      if (!this.clientRegimenId) return 'Régimen fiscal requerido';
      if (!this.clientUsoCfdi) return 'Uso CFDI requerido';
      if (!this.clientPaymentMethod) return 'Forma de pago requerida';
      if (!this.clientPaymentType) return 'Método de pago requerido';
      return true;
    },
    async buildFacturaFromSale(purchaseOrderId) {
      const factura = await InvoicesService.getFacturaSale(purchaseOrderId, 1);
      factura.client = {
        code: String(this.clientRfc || '').trim().toUpperCase(),
        name: String(this.clientName || '').trim(),
        zip_code: String(this.clientCp || '').trim(),
        fiscal_regime_code: String(this.clientRegimenId || '').trim(),
      };
      factura.cfdi_use = {
        code: this.clientUsoCfdi?.code || this.clientUsoCfdi?.value,
        name: this.clientUsoCfdi?.name || this.clientUsoCfdi?.label || '',
      };
      factura.payment_type = {
        code: this.clientPaymentMethod?.code || this.clientPaymentMethod?.value,
        name: this.clientPaymentMethod?.name || this.clientPaymentMethod?.label || '',
      };
      factura.payment_method = {
        code: this.clientPaymentType?.code || this.clientPaymentType?.value,
        name: this.clientPaymentType?.name || this.clientPaymentType?.label || '',
      };
      return factura;
    },
    sanitizeConcepts(factura) {
      if (!Array.isArray(factura?.concepts)) return factura;
      const sanitizedConcepts = factura.concepts.map((c) => {
        const desc = String(c?.name || c?.description || '').trim();
        return {
          ...c,
          name: desc || 'PRODUCTO',
          description: desc || 'PRODUCTO',
        };
      });
      return {
        ...factura,
        concepts: sanitizedConcepts,
      };
    },
    formatSaleRegDate(dateValue) {
      const d = new Date(dateValue);
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    async finishOrder() {
      const ignoreInventory = localStorage.getItem('ignoreInventory') === '1';
      const productsTotal = [];
      const products = [];
      this.block = 1;

      try {
        const toSafeNumber = (v) => {
          const n = Number(v);
          return Number.isFinite(n) ? FPUtils.round2dec(n) : 0;
        };
        const trimMax = (v, max = 100) => String(v || '').trim().slice(0, max);
        const onlyDigits = (v) => String(v || '').replace(/\D/g, '');

        this.itemsList.forEach((x) => {
          const product = new PurchaseOrderProduct(x.id, x.baseCost, x.calculatedDiscount);
          product.isGift = x.isGift;
          products.push(product);
        });

        this.frontItemsList.forEach((item) => {
          if (item.isGift !== 1) {
            productsTotal.push({ productId: item.id, total: item.quantity });
          }
        });

        const paymentsPayload = this.payments
          .map((p) => ({
            totalImport: toSafeNumber(p.totalImport),
            paymentMethod: Number(p.paymentMethod),
            confirmationNumber: trimMax(p.confirmationNumber, 100) || null,
            cardLastDigits: onlyDigits(p.cardLastDigits).slice(0, 4) || null,
            cardBrand: trimMax(p.cardBrand, 100) || null,
            bankName: trimMax(p.bankName, 100) || null,
            change: toSafeNumber(p.change),
          }))
          .filter((p) => p.totalImport > 0 && [1, 2, 3, 4, 5, 6].includes(p.paymentMethod));

        const cashAmount = toSafeNumber(this.realPaidCash);
        const hasCashPayment = paymentsPayload.some((x) => x.paymentMethod === 1);
        if (cashAmount > 0 && !hasCashPayment) {
          paymentsPayload.push({
            totalImport: cashAmount,
            paymentMethod: 1,
            confirmationNumber: null,
            cardLastDigits: null,
            cardBrand: null,
            bankName: null,
            change: toSafeNumber(this.cashChange),
          });
        }

        if (paymentsPayload.length === 0) {
          Swal.fire('Error', 'Debes registrar al menos un pago válido antes de terminar la orden.', 'error');
          this.block = 0;
          return;
        }

        const orderTotal = toSafeNumber(this.cartTotal.total);

        const nonCashPaid = FPUtils.round2dec(
          paymentsPayload.reduce((acc, p) => {
            if (p.paymentMethod === 1) return acc;
            return acc + toSafeNumber(p.totalImport);
          }, 0),
        );

        const cashPaid = FPUtils.round2dec(
          paymentsPayload.reduce((acc, p) => {
            if (p.paymentMethod !== 1) return acc;
            return acc + toSafeNumber(p.totalImport);
          }, 0),
        );

        const cashNeeded = FPUtils.round2dec(Math.max(0, orderTotal - nonCashPaid));
        const effectiveCashPaid = FPUtils.round2dec(Math.min(cashPaid, cashNeeded));

        const netPaidAmount = FPUtils.round2dec(nonCashPaid + effectiveCashPaid);

        if (FPUtils.round2dec(netPaidAmount - orderTotal) < 0) {
          Swal.fire('Error', 'Los pagos no cubren el total de la orden.', 'error');
          this.block = 0;
          return;
        }

        if (this.remainingTotal > 0) {
          Swal.fire('Error', 'No se ha pagado la orden.', 'error');
          this.block = 0;
          return;
        }

        const invoiceValidation = this.validateInvoiceForm();
        if (invoiceValidation !== true) {
          Swal.fire('Error', invoiceValidation, 'error');
          this.block = 0;
          return;
        }

        const { total } = this.cartTotal;
        const employeeId = this.authUserData.user_claims.employee;
        let clientId;
        let clientDiscount = 0;

        if (this.selectedClient && this.selectedClient.id > 0) {
          clientId = this.selectedClient.id;
          clientDiscount = this.selectedClient.discount;
        }

        const resp = await PurchaseOrderService.finishPurchaseOrder(
          employeeId,
          clientId,
          clientDiscount,
          total,
          paymentsPayload,
          products,
          productsTotal,
          ignoreInventory ? 1 : 0,
        );

        this.dialog = false;

        if (resp && resp.error) {
          Swal.fire({
            title: 'Error',
            html: `Hubo un error al registrar los pagos:<br><br>${resp.message || 'Error desconocido'}`,
            icon: 'error',
          });
          this.block = 0;
          this.payments = [];
          this.realPaidCash = 0;
          this.$store.dispatch('clearTotalOrderPaid');
          this.dialog = false;
          this.clearPayment();
          this.resetInvoiceState();
          return;
        }

        if (this.savedQuotationPurchaseOrderId && this.savedQuotationPurchaseOrderId > 0) {
          const quotationOrderId = this.savedQuotationPurchaseOrderId;
          const response = await PurchaseOrderService.finishSavedPurchaseOrder(quotationOrderId);
          if (response && response.error) {
            Swal.fire('Error', 'Hubo un error al registrar los pagos', 'error');
            this.block = 0;
            return;
          }
          this.$store.dispatch('clearSavedQuotationItems');
        }

        await this.printTicket(resp.data.purchaseOrderId);

        let invoiceError = null;
        if (this.invoiceRequired === 'yes') {
          try {
            let factura = await this.buildFacturaFromSale(resp.data.purchaseOrderId);
            factura = this.sanitizeConcepts(factura);
            const invoiceResp = await InvoicesService.postFacturalaSaleInvoice(resp.data.purchaseOrderId, factura);
            if (invoiceResp?.error || invoiceResp?.data?.error) {
              invoiceError = invoiceResp?.message || invoiceResp?.data?.message || 'No se pudo generar la factura';
            }
          } catch (e) {
            invoiceError = e?.message || 'No se pudo generar la factura';
          }
        }

        this.payments = [];
        this.realPaidCash = 0;
        this.$store.dispatch('clearOrder');
        this.$store.dispatch('clearTotalOrderPaid');
        this.dialog = false;
        this.clearPayment();
        this.resetInvoiceState();

        const { store } = this.authUserData.user_claims;
        const payload = await ProductService.getProductAutocompleteData('', 100, store, null);
        this.$store.dispatch('setProductsAutocomplete', payload);

        if (invoiceError) {
          Swal.fire({
            title: 'Venta finalizada',
            icon: 'success',
            html: `
              Se guardaron los pagos y se finalizó la orden.<br><br>
              <div style="background:#fff8e6;border-radius:10px;padding:14px 16px;text-align:left;">
                <div style="color:#d97706;font-weight:700;font-size:20px;line-height:1.2;margin-bottom:6px;word-break:break-word;">
                  ${invoiceError}
                </div>
                <div style="color:#d97706;font-size:18px;line-height:1.35;">
                  Si tienes problemas con el timbrado, realiza la factura en el módulo de
                  <b>Administrador &gt; Facturación</b>.
                </div>
              </div>
            `,
            confirmButtonText: 'Entendido',
          });
        } else if (this.invoiceRequired === 'yes') {
          Swal.fire('Correcto', 'Se guardaron los pagos, se finalizó la orden y se generó la factura.', 'success');
        } else {
          Swal.fire('Correcto', 'Se guardaron los pagos y se finalizó la orden.', 'success');
        }
      } catch (e) {
        console.error(e);
        Swal.fire('Error', 'Ocurrió un error inesperado al finalizar la orden.', 'error');
      } finally {
        this.block = 0;
      }
    },
    resetInvoiceState() {
      this.invoiceRequired = 'no';
      this.billToSelectedClient = 'no';
      this.clearNominativeClientFields();
      this.clientPaymentMethod = null;
      this.clientPaymentType = null;
      this.lockFiscalRegimen = false;
      this.clientRegimen = null;
    },
    clearPayment() {
      this.selectedPayment = 0;
      this.moneyImport = 0;
      this.moneyImport = null;
      this.moneyImport = null;
      this.cardType = null;
      this.transactionChange = '$0.00';
      this.cardLastNumbers = null;
      this.cardBrand = null;
      this.customCardBrand = '';
      this.confirmationNumber = null;
      this.bankName = null;
    },
    getChange() {
      const total = this.remainingTotal > 0 ? this.remainingTotal : 0;
      let change = FPUtils.round2dec(FPUtils.round2dec(this.moneyImport || 0) - total);
      if (change < 0) change = 0;
      this.transactionChange = CurrencyFormatter.format(change);
      this.change = change;
    },
    returnToOrder() {
      if (this.payments.length > 0 || this.realPaidCash) {
        const swal = Swal.fire({
          allowOutsideClick: false,
          title: 'Regresar a orden',
          confirmButtonText: 'Si',
          text: '¿Desea regresar a la orden? Se eliminarán los pagos realizados',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'No',
        });
        swal.then((resp) => {
          if (resp.value) {
            this.clearPayment();
            this.payments = [];
            this.$store.dispatch('clearTotalOrderPaid');
            this.dialog = false;
            this.realPaidCash = 0;
            this.resetInvoiceState();
          }
        });
      } else {
        this.clearPayment();
        this.payments = [];
        this.$store.dispatch('clearTotalOrderPaid');
        this.dialog = false;
        this.realPaidCash = 0;
        this.resetInvoiceState();
      }
    },
    clearPayments() {
      const swal = Swal.fire({
        allowOutsideClick: false,
        title: 'Eliminar pagos',
        confirmButtonText: 'Si',
        text: '¿Seguro que desea eliminar los pagos realizados?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'No',
      });
      swal.then((resp) => {
        if (resp.value) {
          this.clearPayment();
          this.payments = [];
          this.realPaidCash = 0;
          this.change = 0;
          this.transactionChange = 0;
          this.$store.dispatch('clearTotalOrderPaid');
          this.resetInvoiceState();
        }
      });
    },
    async printTicket(id) {
      const data = await PurchaseOrderService.getPurchaseOrderData(id);
      if (this.stompClient && this.stompClient.connected) {
        const ticketData = purchaseOrderToTicketData(data, this.ticketStruct);
        const payload = JSON.stringify(ticketData);
        this.stompClient.send('/exchange/orders/orders', payload, { 'content-type': 'application/json' });
      } else {
        // eslint-disable-next-line no-console
        console.error('no print client connected');
      }
    },
    async preloadInvoiceMisc() {
      const misc = await InvoicesService.getInvoiceMisc();
      const norm = (
        arr,
        codeKeys = ['code', 'value', 'clave', 'key'],
        labelKeys = ['label', 'name', 'descripcion', 'description'],
      ) => (arr || []).map((x) => {
        const code = codeKeys.map((k) => x?.[k]).find((v) => v !== undefined && v !== null && v !== '');
        const label = labelKeys.map((k) => x?.[k]).find((v) => v !== undefined && v !== null && v !== '');
        return {
          ...x,
          code: String(code ?? '').trim(),
          label: String(label ?? '').trim(),
          display: `${String(code ?? '').trim()} - ${String(label ?? '').trim()}`,
        };
      });
      this.cfdis = norm(misc.cfdi_use);
      this.formaPagos = norm(misc.payment_type);
      this.metodoPagos = norm(misc.payment_method);
    },
    async preloadInvoiceClients() {
      this.invoiceClients = await InvoicesService.getClientInvoiceList();
    },
    async loadClientFiscalData() {
      const clientId = this.selectedClient?.id;
      if (!clientId) return;
      try {
        this.loadingClientFiscal = true;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        this.loadingClientFiscal = false;
      }
    },
    findBySatCode(arr, satCode) {
      const norm = (v) => String(v ?? '').trim().toUpperCase();
      const target = norm(satCode);
      if (!target) return null;
      return (arr || []).find((x) => {
        const candidates = [x.value, x.code, x.clave, x.key, x.id, x.satCode, x.sat_code].map(norm);
        return candidates.includes(target);
      }) || null;
    },
    findBySatCodePadded(arr, satCode) {
      const norm = (v) => String(v ?? '').trim().toUpperCase();
      const target = norm(satCode);
      if (!target) return null;
      const alt = target.length === 1 ? `0${target}` : target;
      const alt2 = target.length === 2 && target.startsWith('0') ? String(parseInt(target, 10)) : target;
      return this.findBySatCode(arr, target)
        || this.findBySatCode(arr, alt)
        || this.findBySatCode(arr, alt2)
        || null;
    },
    isSatCutoffCase() {
      const baseDate = new Date();
      const isSaturday = baseDate.getDay() === 6;
      const monday = new Date(baseDate);
      monday.setDate(baseDate.getDate() + 2);
      const mondayIsNextMonth = monday.getMonth() !== baseDate.getMonth();
      const hasCardPayment = this.payments.some(
        (p) => Number(p.paymentMethod) === 2 || Number(p.paymentMethod) === 3,
      );
      return this.invoiceRequired === 'yes' && hasCardPayment && isSaturday && mondayIsNextMonth;
    },
    applyDefaultPaymentConditions() {
      const formaCode = this.satFormaPagoCodeFromPayments();
      const metodoCode = this.satMetodoPagoCode() || 'PUE';
      const isSatCutoffCase = this.isSatCutoffCase();
      if (isSatCutoffCase) {
        this.clientPaymentType = this.findBySatCodePadded(this.metodoPagos, '99');
        this.clientPaymentMethod = this.findBySatCode(this.formaPagos, 'PPD');
      } else {
        this.clientPaymentMethod = metodoCode
          ? this.findBySatCode(this.formaPagos, metodoCode)
          : null;
        this.clientPaymentType = formaCode
          ? this.findBySatCodePadded(this.metodoPagos, formaCode)
          : null;
      }
    },
    async fillNominativeFromSelectedClient() {
      const clientId = this.selectedClient?.id;
      if (!clientId) return;
      try {
        this.loadingFiscal = true;
        if (!this.invoiceClients?.length) await this.preloadInvoiceClients();
        if (!this.cfdis?.length || !this.formaPagos?.length || !this.metodoPagos?.length) {
          await this.preloadInvoiceMisc();
        }
        const item = this.invoiceClients.find((c) => {
          const anyId = c.id ?? c.clientId ?? c.value ?? c.customerId ?? c.personId;
          return Number(anyId) === Number(clientId);
        });
        if (!item) return;
        this.clientCp = item.zipCode ?? item.zip_code ?? item.cp ?? item.postalCode ?? null;
        this.clientName = (
          item.name ?? item.razonSocial ?? item.businessName ?? item.fullName ?? ''
        ).trim() || null;
        this.clientRfc = (
          item.rfc ?? item.taxId ?? item.tax_id ?? item.code ?? ''
        ).trim() || null;
        await this.loadClientFiscalData();
        await this.applyClientFiscalRegime(item);
        if (!this.lockFiscalRegime && this.isValidRfc(this.clientRfc)) {
          await this.loadFiscalRegimens('');
        }
        await this.loadUsoCfdiByRegimen('');
        this.applyDefaultPaymentConditions();
        await this.$nextTick();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        this.loadingFiscal = false;
      }
    },
    clearNominativeClientFields() {
      this.clientName = '';
      this.clientRfc = '';
      this.clientCp = '';
      this.clientRegimenId = null;
      this.clientUsoCfdi = null;
      this.lockFiscalRegimen = false;
      this.fiscalRegimens = [];
      this.usoCfdiItems = [];
      this.invoiceClientOptions = [];
      this.invoiceClientSelected = null;
      this.invoiceClientSearch = '';
    },
    normalizeRegimenList(data = []) {
      return (data || []).map((x) => {
        const id = x?.id ?? x?.value ?? null;
        const rawLabel = String(x?.label ?? x?.name ?? '').trim();
        const match = rawLabel.match(/^\[(\d+)\]\s*(.*)$/);
        const code = String(x?.code ?? (match ? match[1] : '')).trim();
        const name = String(x?.name ?? (match ? match[2] : rawLabel)).trim();
        return {
          id: id != null ? String(id) : null,
          code,
          name,
          label: rawLabel || `${code} - ${name}`,
        };
      }).filter((x) => x.id || x.code);
    },
    async applyClientFiscalRegime(item) {
      const raw = item?.fiscalRegimeCode
        ?? item?.fiscal_regime_code
        ?? item?.fiscalRegimeId
        ?? item?.regimeId
        ?? null;
      if (!raw) {
        this.lockFiscalRegime = false;
        return;
      }
      const rawStr = String(raw).trim();
      const catalogRaw = await ClientService.fiscalRegimeCatalog('');
      const catalog = this.normalizeRegimenList(catalogRaw);
      const found = catalog.find((r) => r.id === rawStr || r.code === rawStr);
      if (found) {
        const satCode = found.code || rawStr;
        const label = found.label || `${satCode} - ${found.name || ''}`.trim();
        this.fiscalRegimens = [{ label, value: satCode }];
        this.clientRegimenId = satCode;
        this.lockFiscalRegime = true;
        return;
      }
      this.clientRegimenId = rawStr;
      this.fiscalRegimens = [{ label: rawStr, value: rawStr }];
      this.lockFiscalRegime = true;
    },
    isValidRfc(rfc) {
      const clean = String(rfc || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
      return clean.length === 12 || clean.length === 13;
    },
    async loadFiscalRegimens(query = '') {
      if (this.lockFiscalRegime) return;
      if (!this.isValidRfc(this.clientRfc)) return;
      const current = this.clientRegimenId;
      const data = await SatService.fiscalRegimeList({
        rfc: this.clientRfc,
        query,
      });
      this.fiscalRegimens = (data || []).map((x) => ({
        label: `[${x.code}] ${x.name}`,
        value: String(x.code),
      }));
      if (current && this.fiscalRegimens.some((x) => String(x.value) === String(current))) {
        this.clientRegimenId = String(current);
      } else if (!current) {
        this.clientRegimenId = null;
      }
    },
    async loadUsoCfdiByRegimen(query = '') {
      const regimen = this.clientRegimenId;
      if (!regimen) {
        this.usoCfdiItems = [];
        this.clientUsoCfdi = null;
        return;
      }
      try {
        this.loadingUsoCfdi = true;
        const data = await SatService.usoCfdiList({ regimen: String(regimen), query });
        this.usoCfdiItems = (data || []).map((x) => ({
          ...x,
          code: String(x.code ?? ''),
          name: String(x.name ?? ''),
          display: `${x.code} - ${x.name}`,
        }));
        const current = this.clientUsoCfdi?.code || this.clientUsoCfdi?.value;
        if (current && !this.usoCfdiItems.some((i) => i.code === String(current))) {
          this.clientUsoCfdi = null;
        }
      } finally {
        this.loadingUsoCfdi = false;
      }
    },
    onlyNumberKeypress(e) {
      const char = String.fromCharCode(e.which || e.keyCode);
      if (!/[0-9]/.test(char)) e.preventDefault();
    },
    onCpPaste(e) {
      const text = (e.clipboardData || window.clipboardData).getData('text') || '';
      this.clientCp = text.replace(/\D/g, '').slice(0, 5);
    },
    async searchInvoiceClient(query) {
      this.invoiceClientSearch = (query || '').trim();
      if (this.invoiceClientSearch.length < 2) {
        this.invoiceClientOptions = [];
        return;
      }
      try {
        this.loadingInvoiceClients = true;
        this.invoiceClientOptions = await InvoicesService.getInvoiceClientsAutocomplete(
          this.invoiceClientSearch,
          20,
        );
      } catch (e) {
        console.error(e);
        this.invoiceClientOptions = [];
      } finally {
        this.loadingInvoiceClients = false;
      }
    },
    async onInvoiceClientChange(selected) {
      if (!selected) return;
      this.clientName = selected.name || '';
      this.clientRfc = (selected.rfc || '').toUpperCase();
      this.clientCp = selected.zipCode || '';
      await this.applyClientFiscalRegime(selected);
      await this.loadUsoCfdiByRegimen('');
    },
  },
  watch: {
    dialog(val) {
      if (!val) this.clearPayment();
    },
    async clientRfc(newVal, oldVal) {
      if (this.lockFiscalRegime) return;
      const clean = (v) => String(v || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
      const n = clean(newVal);
      const o = clean(oldVal);
      if (n === o) return;
      if (n.length === 12 || n.length === 13) {
        await this.loadFiscalRegimens('');
        return;
      }
      this.fiscalRegimens = [];
      this.clientRegimenId = null;
    },
    async invoiceRequired(val) {
      if (val === 'yes') {
        if (!this.cfdis?.length || !this.formaPagos?.length || !this.metodoPagos?.length) {
          await this.preloadInvoiceMisc();
        }
        this.applyDefaultPaymentConditions();
        if (!this.invoiceClients?.length) {
          await this.preloadInvoiceClients();
        }
        this.billToSelectedClient = 'no';
        this.clearNominativeClientFields();
      }
    },
    async selectedClient() {
      if (this.invoiceRequired !== 'yes') return;
      this.billToSelectedClient = 'no';
      this.clearNominativeClientFields();
    },
    async billToSelectedClient(val) {
      if (this.invoiceRequired !== 'yes') return;
      if (val === 'no') {
        this.clearNominativeClientFields();
        return;
      }
      if (this.selectedClient && this.selectedClient.id) {
        await this.fillNominativeFromSelectedClient();
      }
    },
    payments: {
      handler() {
        if (this.invoiceRequired === 'yes') {
          this.applyDefaultPaymentConditions();
        }
      },
      deep: true,
    },
    async realPaidCash() {
      if (this.invoiceRequired === 'yes') {
        this.applyDefaultPaymentConditions();
      }
    },
    async clientRegimenId() {
      await this.loadUsoCfdiByRegimen('');
    },
  },
};
</script>

<style lang="less">
.total-payment-section {
  padding-top: 2rem;
}

.total-payment-label {
  padding: 0;

  h2 {
    font-size: 1.4rem;
    font-weight: 500;
  }
}

.total-payment {
  padding: 0;

  h1 {
    font-weight: 400;
    font-size: 2.6rem;
  }
}

.total-section {
  font-weight: 400;
}

.radio-group-space-around div[role="radiogroup"] {
  display: flex !important;
  width: 100% !important;
  justify-content: space-around !important;
}

.radio-group-space-between div[role="radiogroup"] {
  display: flex !important;
  width: 100% !important;
  justify-content: space-between !important;
}

.payment-finish-card {
  width: 2000px;
  height: 1000px;
}

.finish-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
}

.change-left {
  display: flex;
  align-items: center;
  font-size: 1rem;
}

.client-box {
  border-top: 1px solid rgba(255,255,255,0.12);
  padding-top: 12px;
}

.top-section {
  align-items: stretch;
}

.h-sep {
  border-width: 1px !important;
  opacity: 1 !important;
}

.v-sep {
  height: 100% !important;
  border-width: 1px !important;
  opacity: 1 !important;
}
</style>
